import React, { useEffect, Fragment, useState } from "react";
import Pagination from "../../components/NewPagination";
import {
  ButtonBase,
  Button,
  InputAdornment,
  TextField,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  CircularProgress,
  Switch,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import "./index.css";
import SearchIcon from "@mui/icons-material/Search";

const CardCategoriesData = ({
    isLoading,
    data,
    dataFilter,
    totalDataRecord,
    onChangePage,
    handleUpdate,
}) => {
  return (
    <Card className="gift-cards-category-card">
      <div className="table-title mb-2">
        <span>Gift Card Categories</span>
        <div>
          <TextField
            fullWidth
            variant="standard"
            className="search-input"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "white" }} />
                </InputAdornment>
              ),
            }}
            onChange={(e) => onChangePage("search", e.target.value)}
            value={dataFilter?.search || ""}
          />
        </div>
      </div>
      <div className="gift-cards-table-container mt-5">
        {isLoading ? (
          <div className="flex justify-center items-center p-4">
            <CircularProgress />
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Rate</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((category) => (
                  <tr key={category._id}>
                    <td>{category._id}</td>
                    <td>{category.name}</td>                    
                    <td>{category.rate}</td>
                    <td>
                      {category.status && category.status != "inactive"
                        ? "Active"
                        : "Inactive"}
                    </td>
                    <td>
                      <IconButton
                        onClick={() => handleUpdate(category._id, category.status)}
                        color="primary"
                        disabled={isLoading}
                      >
                        <EditIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="gift-cards-pagination-container">
        <Pagination
          items={totalDataRecord}
          initialPage={dataFilter?.page}
          onChangePage={onChangePage}
          per_page={dataFilter?.limit}
        />
      </div>
    </Card>
  );
};
export default CardCategoriesData;
